import type { ComponentType } from "react";
import type { CommentType } from "../../api/types";
import { AlertTriangle, MessagesSquare, PenLine } from "../../compose/Icon";

/**
 * The colored comment-type badge (rich-comments §12): comment = light blue +
 * message-square, suggestion = yellow + pen-line, request-for-change = red +
 * alert-triangle. Colour is never the only signal — every badge carries its
 * glyph + label (colour-blind safe). The label + glyph maps are exported so the
 * comment-card Row-1 status+type pill (§11) reuses them.
 */

export const TYPE_LABEL: Record<CommentType, string> = {
  comment: "Comment",
  suggestion: "Suggestion",
  "request-for-change": "Change",
};

export const TYPE_GLYPH: Record<CommentType, ComponentType<{ size?: number; strokeWidth?: number }>> = {
  comment: MessagesSquare,
  suggestion: PenLine,
  "request-for-change": AlertTriangle,
};

export function TypeBadge({ type }: { type: CommentType }) {
  const Icon = TYPE_GLYPH[type];
  return (
    <span
      className={`type-badge type-badge--${type}`}
      data-testid={`type-badge-${type}`}
      data-type={type}
    >
      <Icon size={12} strokeWidth={1.75} />
      {TYPE_LABEL[type]}
    </span>
  );
}
